import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { PortalImg } from "./PortalReports";
import { Camera } from "lucide-react";

const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export default function PortalPhotos() {
  const [photos, setPhotos] = useState(null);
  useEffect(() => { api.get("/portal/photo-timeline").then(({ data }) => setPhotos(data)); }, []);
  if (!photos) return <div className="p-6 font-bold uppercase text-sm">Loading photo timeline…</div>;

  const groups = [];
  photos.forEach((p) => {
    const key = (p.date || "").slice(0, 7) || "Undated";
    const g = groups.find((x) => x.key === key);
    if (g) g.items.push(p);
    else groups.push({ key, items: [p] });
  });
  const label = (key) => {
    if (key === "Undated") return "Undated";
    const [y, m] = key.split("-");
    return `${MONTHS[Number(m) - 1] || m} ${y}`;
  };

  return (
    <div className="space-y-6" data-testid="portal-photos">
      {groups.map((g) => (
        <div key={g.key}>
          <div className="font-bold uppercase text-xs text-stone-500 mb-2 flex items-center gap-1.5">
            <Camera size={14} /> {label(g.key)} <span className="text-stone-400 font-normal">· {g.items.length} photo{g.items.length === 1 ? "" : "s"}</span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {g.items.map((p) => (
              <div key={p.id} data-testid={`portal-photo-${p.id}`} className="bg-white border border-stone-200">
                <PortalImg photoId={p.id} className="w-full h-36 object-cover" />
                <div className="p-2">
                  <div className="text-xs font-bold">{p.block_label || "—"} <span className="font-normal text-stone-400">· {p.date}</span></div>
                  {(p.caption || p.category) && <div className="text-[11px] text-stone-500">{p.caption || p.category}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {photos.length === 0 && (
        <div className="bg-white border border-stone-200 p-10 text-center text-stone-400 font-bold uppercase text-sm" data-testid="portal-photos-empty">
          No photos published for your blocks yet — check back after the next scouting visit
        </div>
      )}
    </div>
  );
}
